module.exports = "/images/chat-lg.png?88fd662769109bc927c35c060268f999";